import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import etransportLogo from '../assets/etransport.png';
import menuIcon from '../assets/fi_menu.svg';
import { useAuth } from '../context/AuthContext';
import UserMenu from "./UserMenu";
import MenuItems from "./Menu/MenuItems";

function Header() {
    const { user } = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="header">
            <nav className="header__nav">
                <img
                    className="header__logo"
                    src={etransportLogo} alt="logo"
                    onClick={() => navigate('/')}
                    style={{ cursor: 'pointer' }}
                />
                <ul className="controlList">
                    {user && (
                        <li className="controlList__user--mobile" ref={dropdownRef}>
                            <span onClick={() => setIsDropdownOpen((prev) => !prev)}>
                                <img className="js-iconDown" src={menuIcon} alt="" loading="lazy" id="reviewAccordionIconDown"/>
                            </span>

                            {isDropdownOpen && <UserMenu user={user} onCloseMenu={() => setIsDropdownOpen(false)} />}
                        </li>
                    )}

                    {user && (
                        <li className="controlList__user--desktop">
                            <MenuItems onCloseMenu={() => {}}/>
                            <div className={`userButton`} onClick={logout}>
                                Atsijungti
                            </div>
                        </li>
                    )}
                </ul>
                {!user && (
                    <div className={`userButton`} onClick={() => navigate('/login')}>
                        Prisijungti
                    </div>
                )}
            </nav>
        </div>
    );
}


export default Header;